import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workprogress-form',
  templateUrl: './workprogress-form.component.html',
  styleUrls: ['./workprogress-form.component.css']
})
export class WorkprogressFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/project-progress/work-progress/workprogress-form/workprogress-form.component.ts